module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/ko/2-5c606f0c8d906ef6dc10978b3332bf23.jpg";